import React, { Fragment, PureComponent } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'

import { _Tag } from './styles'


class SelectedFilterTags extends PureComponent {
  handleClick(filterObj, event) {
    if(this.props.onTagClicked) {
      event.preventDefault()
      event.stopPropagation()
      this.props.onTagClicked(filterObj)
    }
  }

  renderTags(selectedFilters) {
    if(!selectedFilters) return null
    // const tagClass = this.props.isRemovable ? css.removableTag : css.tag
    let filterTags = []
    const noCloseIcon = selectedFilters.length === 1
    if(selectedFilters.length) {
      // Set initial tags width to zero and add to it as tags are being added
      filterTags = selectedFilters.map((filterObj) => {
        // when fetching data for the area and building, requireLookup is added
        // after data is received, it will get removed
        if(R.isEmpty(filterObj) || filterObj.requireLookup) return null
        const value = filterObj.title || filterObj.tag || filterObj.filter_value
        return (
          <_Tag
            // currently mobile and desktop shows different ui
            autoCompleteTag={this.props.autoCompleteTag}
            showAutoCompleteMobileTag={this.props.showAutoCompleteMobileTag}
            isRemovable={this.props.isRemovable}
            key={`${filterObj.filter_type}-${filterObj.filter_value}`}
            onMouseDown={this.handleClick.bind(this, filterObj)}
            value={value}
            noCloseIcon={noCloseIcon}
          />
        )
      })
    }
    return this.props.isFilterSearchOpen ? filterTags : null
  }

  render() {
    return typeof window !== 'undefined' ?
      <Fragment>
        {this.renderTags(this.props.lookupAreaTag)}
        {this.renderTags(this.props.selectedFilters)}
      </Fragment> : ''
  }
}


SelectedFilterTags.propTypes = {
  selectedFilters: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  isFilterSearchOpen: PropTypes.bool,
  onTagClicked: PropTypes.func,
  isRemovable: PropTypes.bool,
  showAutoCompleteMobileTag: PropTypes.bool,
  autoCompleteTag: PropTypes.bool,
  lookupAreaTag: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
}

export default SelectedFilterTags

